import { FullTagDescription } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { CartsResponse, UpdateCartRequest } from 'models/Carts'
import { api } from '../api'

const cartsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCart: builder.query<CartsResponse, string>({
      query: (cartId: string) => `/carts/${cartId}`,
      providesTags: (_result, _error, cartId) =>
        [{ type: 'Carts', id: cartId }] as FullTagDescription<never>[],
    }),
    updateCart: builder.query<CartsResponse, { cartId: string; body: UpdateCartRequest }>({
      query: ({ cartId, body }) => ({
        url: `/carts/${cartId}`,
        method: 'PATCH',
        body: body,
      }),
    }),
    deleteItem: builder.mutation<unknown, { cartId: string; itemId: string }>({
      query: ({ cartId, itemId }) => ({
        url: `/carts/${cartId}/cart-items/${itemId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { cartId }) =>
        [{ type: 'Carts', id: cartId }] as FullTagDescription<never>[],
    }),
  }),
})

export const {
  useGetCartQuery,
  useDeleteItemMutation,
  useUpdateCartQuery,
  endpoints: { getCart, deleteItem, updateCart },
} = cartsApi

export default cartsApi
